import {
  ActionIcon as MantineActionIcon,
  type ActionIconProps as MantineActionIconProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type ActionIconProps = CoreComponentProps<MantineActionIconProps, 'button'>;

export function ActionIcon({ testId, view = "all", ...rest }: ActionIconProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineActionIcon data-testid={testId} {...rest} />;
}
